export default "__VITE_ASSET__rxlkn_3j__"